module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "testimonial-wonchul-mobile.82623782.webp";